module.exports = __webpack_public_path__ + "components/flag/static/square/gu-29a48eee4763ef0dc76d1968cdf5d1c6.svg";